import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResponseApi } from '../../../dtos/ResponseApi';
import { SexoResponse } from '../../../dtos/core/sexo/SexoResponse';

@Injectable({
  providedIn: 'root'
})
export class SexoService {
  private baseUrl = `${environment.apiUrl}/core/sexo`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<ResponseApi<SexoResponse[]>> {
    return this.http.get<ResponseApi<SexoResponse[]>>(this.baseUrl);
  }
}
